(function () {
    'use strict';

    // @ngInject
    Services.Modernizr = function Modernizr($window) {
        return $window.Modernizr;
    };
}());
